import { Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';
import { OidcProtectedComponent } from '@nohara/react-oidc';
import { permission } from '@nohara/oidc-core';

import NotFoundRoute from '../not-found';

import { ContentLayout, AdminLayout } from '@/components/layouts';

export const ErrorBoundary = () => {
  const { t } = useTranslation();
  return (
    <AdminLayout>
      <ContentLayout title={t('common.errors.somethingWentWrong')}>Error</ContentLayout>
    </AdminLayout>
  );
};

const permissions = [
  permission.org.read,
  permission.app.read,
  permission.role.read,
  permission.user.read,
];

const AdminRoot = () => {
  return (
    <OidcProtectedComponent requireAny={permissions} fallbackElement={<NotFoundRoute />}>
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </OidcProtectedComponent>
  );
};

export default AdminRoot;
